import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import {
    ProcessStartForm,
    ProcessStartFormProps,
} from 'src/components/ProcessStartForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { Router } from 'src/core/router/Router';
import { ProcessStoreProvider } from 'src/stores/ProcessStore/ProcessStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

type ProcessPageProps = {
    store?: BasicStore<Entity>;
    baseUrl?: string;
    processStartFormProps?: Partial<ProcessStartFormProps>;
};

export const ProcessPage = observer(
    ({ store, baseUrl, processStartFormProps }: ProcessPageProps) => {
        const { params } = useRouteMatch<ProcessPageRouterParams>();

        const { processKey, id } = params;

        const process = ProcessStoreProvider.getInstance(processKey);

        const processContext =
            store && _.merge(store.currentItem, process.getContext);

        useEffect(() => {
            if (!id || !store) {
                return;
            }
            store.loadItem(id);

            return () => {
                store.itemLoader.reset();
            };
        }, []);

        if (store?.itemLoader.isLoading) {
            return <SpinnerFullWidth />;
        }

        return (
            <BasePage pageName={params.processKey} type={PageType.FULL}>
                <ProcessStartForm
                    processKey={params.processKey}
                    context={processContext}
                    onSubmit={() => {
                        baseUrl && Router.navigate(baseUrl);
                    }}
                    onCustomEvent={(event) => {
                        if (event.type === 'navigateToEntityCard' && baseUrl) {
                            event.event.preventDefault();
                            Router.navigate(baseUrl);
                        }
                    }}
                    {...processStartFormProps}
                />
            </BasePage>
        );
    },
);

type ProcessPageRouterParams = {
    processKey: string;
    id?: string;
};
